import _defineProperty from "@babel/runtime/helpers/defineProperty";
export let DomainEventSlug = /*#__PURE__*/function (DomainEventSlug) {
  DomainEventSlug["CREATED"] = "created";
  DomainEventSlug["UPDATED"] = "updated";
  DomainEventSlug["DELETED"] = "deleted";
  DomainEventSlug["ACTION"] = "action";
  return DomainEventSlug;
}({});
export class DomainEvent {
  constructor(event) {
    _defineProperty(this, "entityId", void 0);
    _defineProperty(this, "entity", void 0);
    _defineProperty(this, "eventName", void 0);
    _defineProperty(this, "slug", void 0);
    _defineProperty(this, "eventData", void 0);
    this.eventData = this.convertEventData(event);
    this.entityId = event.entityId;
    this.eventName = event.slug;
    this.slug = this.convertEventSlug(event.slug);
    this.entity = this.parseEntityFromEvent();
  }
  toDuplexerEventPayload() {
    return {
      entityId: this.entityId,
      entity: this.entity
    };
  }
  parseEntityFromEvent() {
    switch (this.eventData.slug) {
      case DomainEventSlug.CREATED:
        return this.parseOrNull(this.eventData.createdEvent.entityAsJson);
      case DomainEventSlug.UPDATED:
        return this.parseOrNull(this.eventData.updatedEvent.currentEntityAsJson);
      case DomainEventSlug.ACTION:
        return this.parseOrNull(this.eventData.actionEvent.bodyAsJson);
      case DomainEventSlug.DELETED:
        return this.parseOrNull(this.eventData.deletedEvent.deletedEntityAsJson);
    }
  }
  getModifiedFields() {
    switch (this.eventData.slug) {
      case DomainEventSlug.CREATED:
      case DomainEventSlug.ACTION:
      case DomainEventSlug.DELETED:
        return null;
      case DomainEventSlug.UPDATED:
        return this.eventData.updatedEvent.modifiedFields;
    }
  }
  convertEventSlug(slug) {
    switch (slug) {
      case 'created':
        return DomainEventSlug.CREATED;
      case 'updated':
        return DomainEventSlug.UPDATED;
      case 'deleted':
        return DomainEventSlug.DELETED;
      default:
        return DomainEventSlug.ACTION;
    }
  }
  parseOrNull(json) {
    try {
      return json ? JSON.parse(json) : null;
    } catch (e) {
      return null;
    }
  }
  convertEventData(event) {
    const {
      id,
      entityId,
      entityFqdn,
      eventTime,
      slug: eventSlug,
      triggeredByAnonymizeRequest
    } = event;
    const slug = this.convertEventSlug(eventSlug);
    const commonEventData = {
      id,
      entityId,
      entityFqdn,
      eventTime,
      triggeredByAnonymizeRequest,
      eventName: eventSlug
    };
    switch (slug) {
      case DomainEventSlug.CREATED:
        return {
          ...commonEventData,
          slug,
          createdEvent: event.createdEvent
        };
      case DomainEventSlug.UPDATED:
        return {
          ...commonEventData,
          slug,
          updatedEvent: event.updatedEvent
        };
      case DomainEventSlug.DELETED:
        return {
          ...commonEventData,
          slug,
          deletedEvent: event.deletedEvent
        };
      case DomainEventSlug.ACTION:
        return {
          ...commonEventData,
          slug,
          actionEvent: event.actionEvent
        };
    }
  }
}
//# sourceMappingURL=DomainEvent.js.map